import '/src/components/UI/Button/IconButton/IconButton.css'
import "./DashboardFormBlockModal.css"

import ButtonAction from "/src/components/UI/Button/Button";
import { blockForm } from "../../../dashboardFormType"
import { ScrollIntoSlide } from '/src/components/slider/sliderView';

function ButtonsSubmitFormBlockModal({typeForm,formState, stateFormGrid,setStateFormGrid,watch,clearErrors, onSubmit, onClose}) {

    return (
        <>
            {
                watch('type') == 0 &&
                <>
                    <ButtonAction className="cancel" label="Cancel" type="button" onClick={() => onClose()} style={{ marginRight: "20px" }} />
                    <ButtonAction className="validate" label={blockForm[typeForm].send} type="submit" disabled={!formState.isValid} />
                </>

            }
            {
                watch('type') == 1 && stateFormGrid == 0 &&
                <>
                    <ButtonAction className="cancel" label="Cancel" type="button" onClick={() => onClose()} style={{ marginRight: "20px" }} />
                    <ButtonAction className="validate" label={"Next"} disabled={!(watch("name").length > 3)} onClick={() => { ScrollIntoSlide("grid_slide_structure"), setStateFormGrid(1) }} />
                </>
            }
            {

                watch('type') == 1 && stateFormGrid == 1 &&
                <>
                    <ButtonAction className="validate" label="Previous" type="button" onClick={() => { ScrollIntoSlide("obligatory"), setStateFormGrid(0), clearErrors() }} style={{ marginRight: "20px" }} />
                    <ButtonAction className="validate" label={"Next"} type="button" onClick={() => { ScrollIntoSlide("grid_slide_variables"), setStateFormGrid(2) }} disabled={ !((watch("type_variable") == 2 && watch("value_dropdown")?.length > 0) || (watch("type_variable") == 1 && watch("default_value")?.length > 0) || watch("type_variable") == 0 || (watch("type_variable") == 4 && watch("default_value_number")?.length > 0)) }/>

                </>
            }
            {

                watch('type') == 1 && stateFormGrid == 2 &&
                <>
                    <ButtonAction className="validate" label="Previous" type="button" onClick={() => { ScrollIntoSlide("grid_slide_structure"), setStateFormGrid(1), clearErrors() }} style={{ marginRight: "20px" }} />
                    <ButtonAction className="validate" label={blockForm[typeForm].send} onClick={() => onSubmit()} disabled={watch("bot_variable_id") == -1} />

                </>
            }
        </>
    );
}

export default ButtonsSubmitFormBlockModal;